





















import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bCol from 'bootstrap-vue/es/components/layout/col';
import bRow from 'bootstrap-vue/es/components/layout/row';

import { ProductVariant } from '@/models';

import QuantityInput from '@/components/QuantityInput.vue';

import BuyboxFeatureComponent from './BuyboxFeatureComponent';

@Component({
  components: {
    QuantityInput,

    bCol,
    bRow,
  },
  props: {
    // Allow two-way binding with v-model.
    value: {
      type: Number,
      required: true,
    },
  },
})
export default class MobileQuantityFeature extends BuyboxFeatureComponent { }

